import {useMutation} from '@tanstack/react-query';

import {postExamBooking} from '../../services/postExamBooking';

export const usePostExamBookingMutation = () => {
	return useMutation({
		mutationFn: postExamBooking,
	});
};
